const translation = {
    confirm: 'Sei sicuro?',
    common: { back: 'Indietro' },
    save: 'Salva',
    returnToGame: 'Sei sicuro di voler rimetterti in gioco?',
    yes: 'SÌ',
    no: 'NO',
    login: {
        auth: 'Autorizzazione',
        noAcc: 'Nessun conto',
        reg: 'Registrati',
        mail: 'Accedi tramite e-mail',
        registration: 'Registrazione',
        agreement: 'Cliccando sul pulsante "Registrati", confermi il tuo',
        agreementLink: 'consenso al trattamento dei dati personali.',
        submit: 'Registrati',
        continue: 'Continua',
        emailLabel: 'E-mail',
        passwordLabel: 'Parola d’ordine',
        repeatPasswordLabel: 'Ripeti la password',
        loginButton: 'Login',
        logout: 'Disconnettersi',
        invalidEmail: 'formato email non valido',
        invalidFormatPassword: 'Formato della password errato',
        forgotPassword: 'Hai dimenticato la password',
        passwordRecovery: 'Recupero della password',
        passwordRecoveryTitle: 'Invieremo una lettera all’e-mail specificata',
        sendLetter: 'Manda una lettera',
        userExists: 'L’utente con questa email esiste',
        userNotExists: 'L’utente con questa email non esiste',
        passwordResetToMail: 'Le istruzioni per reimpostare la password sono state inviate via e-mail',
        passwordValidation: 'Deve contenere da 8 a 20 lettere o numeri latini',
        invalidPassword: 'password errata',
        sessionNotFound: 'Sessione non trovata',
        mismatchPassword: 'Password non corrispondente! Riprova',
        rememberPassword: 'Ricordato la tua password',
        restore: 'Ristabilire',
        accExist: 'Avere un conto',
        confirmationCode: 'Inserisci il codice di conferma inviato via email',
        code: 'Codice di conferma',
        send: 'Inviare',
        confirmation: 'Confermare',
        resend: 'Invia nuovamente',
        codeIsValid: 'Il codice è valido',
        codeNotValid: 'Il codice non è valido',
        newPassword: 'Inserire una nuova password',
        passwordUsedBefore: 'La password è già stata utilizzata in precedenza',
        passwordUpdatedSuccessfully: 'Password aggiornata con successo',
        enterEmail: 'Inserisci il tuo indirizzo email',
        enterPassword: 'Inserire la password',
        enterPasswordAgain: 'Inserisci nuovamente la tua password',
        enterAgreement: 'Conferma il tuo consenso al trattamento dei dati personali',
        notRobot: 'Dimostra che non sei un robot',
        deletionPersonalData: 'Per eliminare i dati personali, inviaci un messaggio alla nostra email.',
    },
    profile: {
        edit: 'Modifica Profilo',
        remove: 'Eliminare l’account',
        projectName: 'Nome del progetto',
        editing: 'Modificare il tuo profilo',
        name: 'Il tuo nome',
        lastName: 'Il tuo cognome',
        inputPattern: 'Da due a dieci lettere',
        purchases: 'Gli acquisti sono assenti',
        settings: 'Impostazioni',
        transactions: 'Transazioni',
    },
    payment: {
        toPay: 'pagare',
        method: 'Metodo di pagamento',
        pay: 'Paga',
        purchases: 'Acquisti',
        paymentMethod: 'Metodo di pagamento',
        debitCard: 'Carta di debito',
        copy: 'ID pagamento copiato!',
        cancellation: 'Sei sicuro di voler annullare il pagamento?',
        email: 'Email per ricevere una ricevuta',
        status: {
            none: 'Nessuno',
            pending: 'In attesa',
            paid: 'Pagato',
            fail: 'Fallito',
        },
        state: {
            progress: 'Pagamento in corso',
            wait: 'Attendere prego',
            paid: 'Pagato',
            successful: 'Pagamento riuscito',
            notPaid: 'Non pagato',
            error: 'Errore',
            cancelled: 'Pagamento annullato',
            cancel: 'Annulla',
        },
    },
    games: {
        header: {
            buttonGuest: 'Ospite',
            buttonLogin: 'Accedi',
            buttonLogout: 'Esci',
        },
        buttonPlay: 'Gioca',
        buttonInDevelop: 'In fase di sviluppo',
    },
    support: {
        noPurchases: 'Non hai ancora acquisti',
        contactSupport: 'Contatta il supporto',
        paymentId: 'ID pagamento',
        userId: 'ID utente',
        requestReason: 'Motivo della richiesta',
        feedbackEmail: 'Email per feedback',
        dropNotCredited: 'Drop non accreditato',
        other: 'Altro',
        success: 'Richiesta accettata',
        successText: 'Abbiamo ricevuto la tua richiesta e ti contatteremo via email a breve',
    },
    receipt: {
        generation: 'Generazione della ricevuta',
        wait: 'Questo potrebbe richiedere del tempo, si prega di attendere.'
    },
}

export default {
    translation,
}
